import React, { useEffect, useState } from 'react';
export function StickyFooterBar() {
  const [isVisible, setIsVisible] = useState(false);
  const getCtaUrl = () => {
    const base = 'https://f3477bvkt01did2lv7on8yp83y.hop.clickbank.net/?&traffic_source=facebook&traffic_type=paid&campaign=pianoforall-v2&ad=ad-1';
    const fbclid = sessionStorage.getItem('fbclid');
    if (!fbclid) return base;
    return `${base}&fbclid=${fbclid}`;
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight) * 100;
      setIsVisible(scrollPercent > 35);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <a href={getCtaUrl()} target="_blank" rel="noopener noreferrer" className={`fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-[#8B1538] to-[#A61F3F] text-white shadow-[0_-4px_12px_rgba(0,0,0,0.3)] border-t border-[#A61F3F] transition-all duration-500 ease-in-out hover:brightness-110 cursor-pointer block no-underline ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 py-3 md:py-4" data-id="element-13">
        {/* Desktop: single row */}
        <div className="hidden md:flex items-center justify-between" data-id="element-14">
          <span className="text-white font-bold text-base flex items-center gap-1.5" data-id="element-15">
            → Start Playing Piano Today
            <span className="text-amber-200 font-normal text-base" data-id="element-16">
              · 500,000+ Students · 4.8 ⭐
            </span>
          </span>
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-17">
            <span className="line-through text-white/70 text-base" data-id="element-18">$79</span>
            <span className="text-3xl font-extrabold text-yellow-300 animate-pulse" data-id="element-19">
              $49
            </span>
            <span className="text-amber-200 text-base" data-id="element-20">· 60-Day Guarantee</span>
          </span>
        </div>

        {/* Mobile: stacked */}
        <div className="flex flex-col items-center gap-1.5 md:hidden" data-id="element-21">
          <span className="text-white font-bold text-sm" data-id="element-22">
            → Start Playing Piano Today
          </span>
          <span className="flex items-center gap-2 whitespace-nowrap" data-id="element-23">
            <span className="line-through text-white/70 text-sm" data-id="element-24">$79</span>
            <span className="text-2xl font-extrabold text-yellow-300 animate-pulse" data-id="element-25">
              $49
            </span>
          </span>
          <span className="text-amber-200 text-sm" data-id="element-26">
            500,000+ Students · 4.8 ⭐ · 60-Day Guarantee
          </span>
        </div>
      </div>
    </a>;
}